<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!--<a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.content.field']">
              <a-select v-model="queryParam.colId" allowClear  :disabled="isDisable">
                <a-select-option v-for="(item,index) in cols" :key="index" :value="item.id" allowClear>
                  {{ item.colName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.develop.contTitle']">
              <a-input v-model="queryParam.contentTitle" :placeholder="language['ad.must']+language['emp.develop.contTitle']" allowClear></a-input>
            </a-form-item>
          </a-col>
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="是否第三方内容">-->
<!--              <j-dict-select-tag placeholder="请选择是否第三方内容" v-model="queryParam.isThird" dictCode="hhemp_isthird"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <!--<a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['platform.roleUser.columns2.status']">
              <j-dict-select-tag :placeholder="language['column.pleaseChoose']+language['platform.roleUser.columns2.status']"  v-model="queryParam.publishStatus" dictCode="hhemp_publish_status" allowClear/>
            </a-form-item>
          </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['common.language']">
              <!--<j-dict-select-tag :placeholder="language['column.pleaseChoose']+language['platform.roleUser.columns2.status']"  v-model="queryParam.publishStatus" dictCode="hhemp_publish_status" allowClear/>-->
              <a-radio-group v-model="queryParam.langCode" @change="searchQuery">
                <a-radio :value="item.value" v-for="(item,index) in this.$store.getters.languagelist" :key="index.toString()">{{ language[item.value] }}</a-radio>
                <!--<a-radio value="0" >{{ language['common.no']}}</a-radio>-->
              </a-radio-group>
            </a-form-item>
          </a-col>

          <!--<template v-if="toggleSearchStatus">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.content.number']">
              <a-input :placeholder="language['ad.must']+language['emp.content.number']" v-model="queryParam.contentCode" allowClear></a-input>
            </a-form-item>
          </a-col>
          </template>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
              <!--<a-button v-if="onlyView" @click="goback" type="primary" icon="left" style="margin-left: 8px">{{this.language['portal.goBack']}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton']  : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator" >
      <!--<a-button @click="handleAdd" v-has="'cmscontent:insert'"  type="primary" icon="plus">{{this.language['common.insertButton']}}</a-button>
      <a-button @click="goback" type="primary" icon="left">{{this.language['portal.goBack']}}</a-button>-->
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="2" v-has="'cmscontent:batchUpdown'"  @click="batchPublish('published',language['ad.online'])"><a-icon type="delete"/>{{language['ad.online']}}</a-menu-item>
          <a-menu-item key="2" v-has="'cmscontent:batchUpdown'"  @click="batchPublish('unpublished',language['ad.offline'])"><a-icon type="delete"/>
            {{ language['ad.offline'] }}</a-menu-item>
          <a-menu-item key="1" v-has="'cmscontent:batchDelete'"  @click="batchDel"><a-icon type="delete"/>{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"

        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
            <img v-else :src="getImgViewCode(text,applicationCode)" @click="imgView(getImgViewCode(text,applicationCode))" height="25px" width="50px" alt="" style="max-width:80px;max-height:160px;font-size: 12px;font-style: italic;cursor: pointer;"/>
          </div>
          <a-modal
            :mask="false"
            :width="1000"
            title="图片"
            :visible="previewVisible"
            :confirm-loading="false"
            :ok-button-props="{ props: { disabled: true } }"
            @cancel="handleCancel"
            :cancelText="language['common.closeButton']">
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>
        <span slot="publisher" slot-scope="text,record">
          <span v-if="record.publishStatus=='published'">
            <p>{{record.publisherName}}</p>
            <p >({{record.publisher}}) </p>
          </span>
        </span>
        <span slot="action" slot-scope="text, record">
<!--          <a @click="handleContent(record)">查看</a>-->
          <a @click="handleContent(record)">{{language['common.detailsButton']}}</a>
          <a-divider type="vertical" />
          <a @click="agree(record)" >{{language['emp.contentCheck.agreeBtn']}}</a>
          <a-divider type="vertical" />
          <a @click="reject(record)" >{{language['emp.contentCheck.rejectBtn']}}</a>
       <!--<a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'cmscontent:detail'" >
                <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item v-has="'cmscontent:delete'" >
                  <a-popconfirm :title="language['esg.IsDeleted']" @confirm="() => handleDelete(record.id)">
                               <a>{{language['ispforum.delete']}}</a>
                  </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>-->
        </span>


      </a-table>
    </div>

    <!--<cms-content-tbl-check-modal ref="modalForm" @ok="modalFormOk"  :pageLangCode="queryParam.langCode"></cms-content-tbl-check-modal>-->
    <CmsDataCheckModel ref="checkModel"></CmsDataCheckModel>
    <j-modal
      :title="''"
      :width="500"
      :visible="rejectedModelVisible"
      @ok="rejectedOk"
      @cancel="rejectedCancel"
      :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
      :cancelText="language['common.cancel']">
      <a-spin :spinning="rejectedModelConfirmLoading">
        <j-form-container >
          <a-form-model ref="rejectedform" :model="rejectedData" :rules="rejectedModelValidatorRules" slot="detail">
            <a-row>
              <a-col :span="24">
                <a-form-model-item :label="language['emp.contentCheck.rejectedRemarks']"  prop="checkRemarks">
                  <a-textarea maxlength='500'  :auto-size="{ minRows: 2, maxRows: 5 }" v-model="rejectedData.checkRemarks"  ></a-textarea>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </j-form-container>
      </a-spin>

    </j-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import CmsContentTblCheckModal from './modules/CmsContentTblCheckModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { httpAction,getAction } from '@/api/manage'
  import { filterObj } from '@/utils/util';
  import CmsDataCheckModel from './modules/CmsDataCheckModel'
  import { filterDictText } from '@/components/dict/JDictSelectUtil'
  import { getDictItemsFromCache } from '@/api/api'

  export default {
    name: 'CmsDataCheckList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      CmsContentTblCheckModal,
      CmsDataCheckModel
    },
    props: {
      // colid: String,
      onlyView: {
        type: Boolean,
        default: false
      }
    },
    data () {
      const { language } = this.$store.getters;
      return language&&{
        queryParam:{
          langCode:window.sessionStorage.getItem('USER_LANGUAGE')
        },
        isDisable:false,
        description: 'cms_content_tbl管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:50,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },

          {
            title: language['emp.develop.contTitle'],
            align: "center",
            dataIndex: 'title',
            // width: 200,
            ellipsis: true,
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          /*{
            title:language['emp.apptype.entrance'],
            align:"center",
            dataIndex: 'entranceName',
            width: 150,
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },*/
          /*{
            title:language['emp.content.field'],
            align:"center",
            dataIndex: 'colName',
            width: 200,
            customRender:function (text,record){
              if(record.parentColId==null){
                return record.colName
              }else{
                return record.parentColName
              }
            },
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },*/
          {
            title:language['emp.col.colLevel_two'],
            align:"center",
            dataIndex: 'catalogName',
            width: 200,
            /*customRender:function (text,record){
              if(record.parentColId==null){
                return '-'
              }else{
                return record.colName
              }
            },*/
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          /*{
            title:'内容标题',
            align:"center",
            dataIndex: 'contentTitle'
          },*/
          /*{
            title:language['legalperson'],
            align:"center",
            width: 150,
            dataIndex: 'legalPerson',
          },*/
          /*{
            title:language['emp.col.colLevel'],
            align:"center",
            // dataIndex: 'contentType_dictText',
            width: 150,
            dataIndex: 'contentType',
            ellipsis: true,
            customRender: (text) => (text ? filterDictText(this.contentTypeDictList, text) : ''),
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },*/
          /*{
            title:language['platform.roleUser.columns2.status'],
            align:"center",
            // dataIndex: 'publishStatus_dictText',
            width: 100,
            dataIndex: 'status',
            customRender: (text) => (text ? filterDictText(this.publishStatusDictList, text) : ''),
          },*/
          /*{
            title:language['common.sort'],
            align:"center",
            dataIndex: 'sortNo',
            width: 80,
          },*/
          // {
          //   title:'内容来源',
          //   align:"center",
          //   dataIndex: 'publishApplicationName'
          // },
          /*{
            title:language['emp.col.publisher'],
            align:"center",
            dataIndex: 'publisher',
            width: 100,
            scopedSlots: {customRender: "publisher"},
          },*/
          // {
          //   title:'发布时间',
          //   align:"center",
          //   dataIndex: 'publishTime'
          // },
          /*{
            title:language['emp.col.publishTime'],
            align:"center",
            dataIndex: 'publishTime',
            width: 150,
            customRender:function (text,record) {
              if(record.publishStatus=='published') {
                if (record.publishTimeHand !=null) {
                  return record.publishTimeHand;
                }
                else{
                return  record.publishTime;
                }
              }else{
                 return "";
              }
            }
          },*/
          /*{
            title:language['common.createTime'],
            align:"center",
            dataIndex: 'contentCreateBy',
            width: 180,
            customRender:function (text) {
              return !text?"":(text.length>19?text.substr(0,19):text)
            }
          },*/
          {
            title:language['common.creator'],
            align:"center",
            dataIndex: 'contentCreateRealName',
            width: 180,
          },
          {
            title:language['common.createTime'],
            align:"center",
            dataIndex: 'contentCreateTime',
            width: 180,
            customRender:function (text) {
              return !text?"":(text.length>19?text.substr(0,19):text)
            }
          },
          /*{
            title:'发布应用',
            align:"center",
            dataIndex: 'publishApplications_dictText'
          },*/
          /*{
            title:'网址',
            align:"center",
            dataIndex: 'contentUrl'
          },*/
          /*{
            title:'排序',
            align:"center",
            dataIndex: 'sortNo'
          },*/
          /*{
            title:'刪除标示',
            align:"center",
            dataIndex: 'delFlag'
          },*/
          /*{
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },*/
          {
            title: language['common.action'],
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:200,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/hhemp/contentcheck/queryCmsContentPage",
          delete: "/hhemp/content/cmscontenttbl",
          deleteBatch: "/hhemp/content/cmscontenttbl/batch",
          exportXlsUrl: "/hhemp/content/export-xls",
          importExcelUrl: "hhemp/content/import-excel",
          publish: "/hhemp/content/publishstatus",
          publishBatch: "/hhemp/content/publishstatus/batch",
        },
        dictOptions:{},
        superFieldList:[],
        cols:[{
          id:'',
          colName:''
        }],
        applicationCode:'hhemp',
        previewVisible: false,
        previewImage: '',
        disableMixinCreated: false,


        rejectedModelVisible:false,
        rejectedModel:{},
        rejectedModelConfirmLoading:false,
        rejectedModelValidatorRules:{
          checkRemarks:[
            { required: true, message: language['ad.must']+language['emp.contentCheck.rejectedRemarks']},
          ],
        },
        rejectedData:{},
      }
    },
    created() {
      this.publishStatusDictList = getDictItemsFromCache('hhemp_publish_status');
      this.contentTypeDictList = getDictItemsFromCache('emp_content_type');
      /*this.$set(this.dictOptions, 'publishStatus', [{text:'是',value:'Y'},{text:'否',value:'N'}])*/
      this.getSuperFieldList();
      // this.getColList();
      /*let that = this;
      if(this.$route.query.colid != undefined){
        this.queryParam.colId = this.$route.query.colid;
        this.loadData();
      }else{
        this.loadData();
      }*/

    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      agree(record){
        this.loading = true
        getAction("/hhemp/contentcheck/checkCMSContent",{'readyCheckId':record.readyCheckId,'checkStatus':'Y'}).then(res=> {
          if (res.success) {
            this.searchQuery();
          }
        }).finally(() => {
          this.loading = false;
        })
      },
      reject(record){
        this.rejectedData.readyCheckId = record.readyCheckId
        this.rejectedData.checkStatus = 'N'
        this.rejectedModelVisible = true;
      },
      rejectedOk(){
        this.$refs.rejectedform.validate(valid => {
          if (valid) {
            this.rejectedModelConfirmLoading = true
            getAction("/hhemp/contentcheck/checkCMSContent",this.rejectedData).then(res=>{
              if(res.success){
                this.rejectedData = {};
                this.rejectedModelVisible = false
                this.searchQuery();
              }else{
                this.$message.warning(res.message);
              }
            }).finally(() => {
              this.rejectedModelConfirmLoading = false;
            });
          }
        })
      },
      rejectedCancel(){
        this.rejectedData = {};
        this.rejectedModelVisible = false
      },
      searchReset(){
        this.queryParam={
          langCode:window.sessionStorage.getItem('USER_LANGUAGE'),
          // colId : this.colid
        }
        this.loadData(1);
      },
      goback(){
        this.$parent.tabChange(null);
      },
      /*batchPublish(status,title){
        var that = this;
        //上架
        this.$confirm({
          title:title,
          content:this.language['common.sure']+title+this.language['common.selected.data']+"?",
          onOk: function(){

            if (that.selectedRowKeys.length <= 0) {
              that.$message.warning(this.language['tip.messageSelectRecord']);
              return;
            } else {
              var ids = "";
              for (var a = 0; a < that.selectedRowKeys.length; a++) {
                ids += that.selectedRowKeys[a] + ",";
              }
              getAction(that.url.publishBatch,{ids:ids,status:status}).then((res)=>{
                if(res.success){
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                }else{
                  that.$message.warning(res.message);
                }
              });

            }
          }
        });
      },*/
      initDictConfig(){
      },
      getQueryParams() {
        // 路由参数
        if(this.colid!=null) {
          this.queryParam.colId = this.colid;
          this.isDisable=true;
          // this.getColList();
        }
        if(this.$route.query.colid != undefined){
          this.queryParam.colId = this.$route.query.colid;
          this.$route.query.colid = null;
        }
        //获取查询条件
        let sqp = {}
        if(this.superQueryParams){
          sqp['superQueryParams']=encodeURI(this.superQueryParams)
          sqp['superQueryMatchType'] = this.superQueryMatchType
        }
        var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },
      getSuperFieldList(){
        let fieldList=[];
        /*fieldList.push({type:'string',value:'colName',text:'栏位',dictCode:''})*/
        fieldList.push({type:'string',value:'contentTitle',text:'内容标题',dictCode:''})
        /*fieldList.push({type:'string',value:'imgUrl',text:'图片',dictCode:''})*/
        fieldList.push({type:'string',value:'isThird',text:'是否第三方内容',dictCode:'hhemp_isthird'})
        fieldList.push({type:'string',value:'publishStatus',text:'发布状态',dictCode:'hhemp_publish_status'})
        fieldList.push({type:'string',value:'publisher',text:'发布人',dictCode:''})
        fieldList.push({type:'date',value:'publishTime',text:'发布时间'})
        /*fieldList.push({type:'string',value:'publishApplications',text:'发布应用',dictCode:'hhemp_applications'})*/
        fieldList.push({type:'string',value:'contentUrl',text:'网址',dictCode:''})
        fieldList.push({type:'int',value:'sortNo',text:'排序',dictCode:''})
        /*fieldList.push({type:'string',value:'delFlag',text:'刪除标示',dictCode:''})*/
        fieldList.push({type:'string',value:'remark',text:'备注',dictCode:''})
        this.superFieldList = fieldList
      },
      /*getColList(){
        let url = ""
        if(this.colid){
          url = "/hhemp/col/getVOById"
        }else{
          url = "/hhemp/col/cmscoltblAll"
        }
        getAction("/hhemp/col/getVOById",{id:this.colid,entranceCode:this.$store.getters.applicationCode}).then((res) => {
          if (res.success) {
            this.cols = [res.result];
          }
        })
      },*/
      /*publish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:this.language['emp.col.status.publish'],
          content:this.language['emp.col.status.sureUpShelf'],
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'published'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },*/
      /*unpublish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:this.language['ad.offline'],
          content:this.language['emp.apptype.sureDownShelf'],
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'unpublished'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },*/
      imgView(text){
        this.previewImage = text;
        this.previewVisible = true;
      },
      // 关闭模态框
      handleCancel() {
        this.previewVisible = false;
      },
      handleContent(record){
        this.$refs.checkModel.detail(record);
      },
    }
    ,mounted() {
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
